import { createUuid } from '@core/utils';
import { captureException } from '@sentry/nextjs';

import { AuthApi, UnauthApi } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { LOCAL_STORAGE_KEY } from '@/stores/GlobalStore';
import { isBot } from '@/utils/isBot';

export const getOrCreateWelloUuid = (): string => {
  try {
    const storedUuid = localStorage.getItem(LOCAL_STORAGE_KEY.WELLO_UUID);
    if (storedUuid) {
      return storedUuid;
    }
    const newUuid = createUuid();
    localStorage.setItem(LOCAL_STORAGE_KEY.WELLO_UUID, newUuid);

    return newUuid;
  } catch (error) {
    captureException(error);

    return createUuid();
  }
};

export const postWelloTrack = async ({
  eventName,
  dictionary,
}: {
  eventName: string;
  dictionary: Record<string, unknown>;
}) => {
  if (isBot()) {
    return;
  }

  const { isLogin } = useAuthStore.getState();
  //* 스프레드 뒤에 주입해 호출처가 dictionary.welloUuid를 실수로 덮지 못하게 한다.
  const requestBody = {
    eventName,
    dictionary: { ...dictionary, welloUuid: getOrCreateWelloUuid() },
  };

  return isLogin
    ? AuthApi['post:/wello/v2/auth/wello-track']({ body: requestBody })
    : UnauthApi['post:/wello/v2/allows/wello-track']({ body: requestBody });
};

type BenefitQuickMenuClickTarget =
  | { tileType: 'BENEFIT_MENU'; benefitMenuId: string }
  | { tileType: 'MERCHANT'; merchantCode: string };

export const postBenefitQuickMenuClick = ({
  appYN,
  ...target
}: BenefitQuickMenuClickTarget & { appYN: boolean }) => {
  if (isBot()) {
    return;
  }

  const { isLogin } = useAuthStore.getState();
  const requestBody = { ...target, welloUuid: getOrCreateWelloUuid(), appYN };
  //* 페이지 이동으로 요청이 끊기지 않게 keepalive로 보낸다.
  const request = isLogin
    ? AuthApi['post:/wello/v2/auth/benefit-quick-menu-clicks']({
        body: requestBody,
        keepalive: true,
      })
    : UnauthApi['post:/wello/v2/allows/benefit-quick-menu-clicks']({
        body: requestBody,
        keepalive: true,
      });

  request.catch(captureException);
};
